var _defs, _path, _rect, _rect2, _rect3, _path2, _path3, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _polyline, _path4, _polyline2, _path5, _circle12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIllustrationsStep1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#556262;}.cls-2,.cls-6{fill:none;}.cls-2,.cls-3{stroke:#9da4a4;}.cls-2,.cls-3,.cls-6{stroke-miterlimit:10;}.cls-3{fill:#fff;}.cls-4{fill:#dadede;}.cls-5{fill:#5dd9c5;stroke:#18a795;stroke-linejoin:round;}.cls-6{stroke:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Illustrations") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M61,20a2,2,0,0,1,2,2V51a2,2,0,0,1-2,2H11a2,2,0,0,1-2-2V22a2,2,0,0,1,2-2H61m0-1H11a3,3,0,0,0-3,3V51a3,3,0,0,0,3,3H61a3,3,0,0,0,3-3V22a3,3,0,0,0-3-3Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 10.5,
    y: 21.5,
    width: 28,
    height: 30,
    rx: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 40.5,
    y: 21.5,
    width: 21,
    height: 14,
    rx: 1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 40.5,
    y: 37.5,
    width: 21,
    height: 14,
    rx: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M33.5,33.5c0,6-2,5-2,10v1c0,2.76-2.24,4-5,4h0c-7,0-11-8-11-15h0a9,9,0,0,1,18,0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M32,34c0,5-2.44,4.63-2.44,7.52v.72c0,2,.44,4.89-3.62,4.89h0c-5.05,0-8.94-7.78-8.94-12.84h0c0-5.29,3.91-8.5,7.5-8.5,4.5,0,7.5,4.21,7.5,8.5Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 46.5,
    cy: 48.5,
    r: 0.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 48.5,
    cy: 48.5,
    r: 0.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 50.5,
    cy: 48.5,
    r: 0.5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 52.5,
    cy: 48.5,
    r: 0.5
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 54.5,
    cy: 48.5,
    r: 0.5
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 47.5,
    cy: 46.5,
    r: 0.5
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 49.5,
    cy: 46.5,
    r: 0.5
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 51.5,
    cy: 46.5,
    r: 0.5
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 53.5,
    cy: 46.5,
    r: 0.5
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 55.5,
    cy: 46.5,
    r: 0.5
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 56.5,
    cy: 48.5,
    r: 0.5
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "45 28 45 32.5 48 32.5 48 28"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M48.5,25.5a2.06,2.06,0,0,0-.26,0,2,2,0,0,0-3.48,0,2.06,2.06,0,0,0-.26,0,2,2,0,1,0,1.74,3,1.14,1.14,0,0,0,.52,0,2,2,0,1,0,1.74-3Z"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "54.5 28 54.5 32.5 57.5 32.5 57.5 28"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M58,25.5a2.06,2.06,0,0,0-.26,0,2,2,0,0,0-3.48,0,2.06,2.06,0,0,0-.26,0,2,2,0,1,0,1.74,3,1.14,1.14,0,0,0,.52,0,2,2,0,1,0,1.74-3Z"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 23.5,
    cy: 32.5,
    r: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationsStep1);
export default __webpack_public_path__ + "static/media/Illustrations_Step1.24281067ea835bf037ee842df595ffbe.svg";
export { ForwardRef as ReactComponent };